import './App.css';
import { useMemo } from 'react';
import * as anchor from '@project-serum/anchor';
import Home from './Home';

import { clusterApiUrl } from '@solana/web3.js';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletWallet,
  getSolletExtensionWallet,
} from '@solana/wallet-adapter-wallets';

import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react';
import { WalletDialogProvider } from '@solana/wallet-adapter-material-ui';

import { ThemeProvider, createTheme } from '@material-ui/core';

const theme = createTheme({
  palette: {
    type: 'dark',
  },
});

const getCandyMachineId = (): anchor.web3.PublicKey | undefined => {
  try {
    const candyMachineId = new anchor.web3.PublicKey(
      process.env.REACT_APP_CANDY_MACHINE_ID!,
    );

    return candyMachineId;
  } catch (e) {
    console.log('Failed to construct CandyMachineId', e);
    return undefined;
  }
};

const candyMachineId = getCandyMachineId();
const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;
const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(
  rpcHost ? rpcHost : anchor.web3.clusterApiUrl('devnet'),
);

const txTimeoutInMilliseconds = 30000;

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSlopeWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    [],
  );

  return <div className="container"></div>;
};

/* 
previous bg image
<img className="bg" src="https://i.imgur.com/B6eWvZ0.png" alt="" />


previous roadmap images
<img src="https://i.imgur.com/RcM6I0w.png" alt="" />
<img src="https://i.imgur.com/k2mCnen.png" alt="" />


previous mint images
<img src="https://i.imgur.com/YvpDuMz.png" alt="" />
<img src="https://i.imgur.com/pcKLZ2u.png" alt="" />
<img src="https://i.imgur.com/dhNC48I.png" alt="" />
<img src="https://i.imgur.com/rjKruzs.png" alt="" />
<img src="https://i.imgur.com/q9WetIb.png" alt="" />
<img src="https://i.imgur.com/QMyDvxf.png" alt="" />

<div className="logo footer-logo">
 <img src="https://i.imgur.com/tGDSqpel.png" alt="" />
 
 mnkynft@gmail.com
 MNKYBANANANFT
 https://discord.gg/VP6FMR7v
 @MNKY_BANANA

 </div>
*/

export default App;
